import gql from "graphql-tag";

export const GET_TOKEN = gql`
    mutation GetToken($email: String!, $password: String!) {
        tokenAuth (email: $email, password: $password){
            token
        }
    }
`;
